import {
  FORMAT_DECIMAL_VALUE,
  KEY_GENERATOR,
} from "../../../../functions/funtion";
import { dto_StartupPageLoadInfo } from "../../../../classes/dto-mobile-settings";
import { F_Fammily, Font } from "../../../../util/config-fonts";
import { dto_common } from "../../../../classes/dto-common";
import { Colors } from "../../../../util/colors";
import { CSP } from "../../../../config/config";
import QtyPlusViewOnProductListView from "../pg-product-list-qty/product-list-item-wise-qty";
import React from "react";
import "../../../../styles/css/pg-filter-outlets-products.css";

export default class FilterItemComponent extends React.PureComponent {
  render() {
    let data = this.props.data;

    return (
      <>
        <div
          className="features pgFilterItemList"
          key={KEY_GENERATOR()}
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            marginLeft: 10,
            marginRight: 10,
            marginBottom: 10,
            cursor: "pointer",
          }}
          onClick={() => {
            this.props.ItemClick(data);
          }}
        >
          <div
            className="fadeInUp animated "
            data-wow-duration="300ms"
            data-wow-delay="0ms"
          >
            <div style={{ display: "flex", textAlign: "left" }}>
              <div className="pgFilterItemListRow" style={{ width: "100%" }}>
                <p
                  style={{
                    margin: 0,
                    fontSize: Font.Heading,
                    fontFamily: F_Fammily.Medium,
                  }}
                >
                  {data.D}
                </p>
                {data.GenDesc !== "" ? (
                  <p
                    style={{
                      margin: 0,
                      fontSize: Font.Description,
                      fontStyle: "italic",
                    }}
                  >
                    {data.GenDesc}
                  </p>
                ) : null}
                {data.UD > 0 ? (
                  <div style={{ display: "flex" }}>
                    <p
                      style={{
                        paddingTop: 0,
                        margin: 0,
                        fontSize: Font.Amount,
                        color: "red",
                        alignSelf: "stretch",
                        textDecorationLine: "line-through",
                        textDecorationStyle: "solid",
                        marginRight: 5,
                      }}
                    >
                      {dto_StartupPageLoadInfo.Currency}
                      {"  "}
                      {FORMAT_DECIMAL_VALUE(2, data.P, 2)}
                    </p>
                    <p
                      style={{
                        paddingTop: 0,
                        color: Colors.ThemeBGcolor,
                        margin: 0,
                        fontSize: Font.Amount,
                      }}
                    >
                      {dto_StartupPageLoadInfo.Currency}
                      {"  "}
                      {FORMAT_DECIMAL_VALUE(
                        2,
                        parseFloat(data.P) - parseFloat(data.UD),
                        2
                      )}
                    </p>
                  </div>
                ) : (
                  <p
                    style={{
                      paddingTop: 0,
                      color: this.props.ThemeColor,
                      margin: 0,
                      fontSize: Font.Amount,
                    }}
                  >
                    {dto_StartupPageLoadInfo.Currency}
                    {"  "}
                    {FORMAT_DECIMAL_VALUE(2, parseFloat(data.P), 2)}
                  </p>
                )}

                {data.IsAvailable ? (
                  <p
                    style={{
                      margin: 0,
                      fontSize: Font.SmallDescription,
                      color: "green",
                    }}
                  >
                    Available
                  </p>
                ) : (
                  <p
                    style={{
                      margin: 0,
                      fontSize: Font.SmallDescription,
                      color: "red",
                    }}
                  >
                    Not Available
                  </p>
                )}
                <div style={{ display: "flex" }}>
                  <p
                    style={{
                      margin: 0,
                      fontSize: Font.MiniDiscription,
                      color: "orange",
                      marginRight: 5,
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      maxWidth: CSP === "MK" ? "" : "14ch",
                    }}
                  >
                    {CSP === "MK" ? data.CA : data.Merchant}
                  </p>
                  <p
                    style={{
                      display: CSP === "MK" ? "none" : "block",
                      color: "orange",
                      margin: 0,
                      fontSize: Font.MiniDiscription,
                      marginRight: 5,
                    }}
                  >
                    {" |"}
                  </p>

                  <p
                    style={{
                      display: CSP === "MK" ? "none" : "block",
                      margin: 0,
                      fontSize: Font.MiniDiscription,
                      marginRight: 5,
                    }}
                  >
                    {data.Add1}
                    {" |"}
                  </p>

                  <p
                    style={{
                      display: CSP === "MK" ? "none" : "block",
                      margin: 0,
                      fontSize: Font.MiniDiscription,
                      color: data.IO === true ? "green" : "red",
                      marginRight: 3,
                    }}
                  >
                    {data.MS}
                  </p>
                </div>
              </div>

              <div className="">
                {data.IU !== "" && data.IU !== "N/A" ? (
                  <img
                    style={{
                      height: 60,
                      width: 60,
                      padding: 0,
                    }}
                    loading="lazy"
                    id={"prdImageLise" + data.PID}
                    // src={"https://www.daitonnmail.com/" + data.IU + "?_=" + new Date().getTime()}
                    src={data.IU + "?_=" + new Date().getTime()}
                    alt=""
                    onError={(e) => {
                      e.currentTarget.src = dto_common.DefaultImageUrl;
                    }}
                  />
                ) : (
                  <img
                    style={{
                      height: 60,
                      width: 60,
                      padding: 0,
                    }}
                    src={dto_common.DefaultImageUrl}
                    alt=""
                  />
                )}
                <div style={{ display: CSP === "MK" ? "block" : "none" }}>
                  <QtyPlusViewOnProductListView
                    style={{ position: "absolute" }}
                    item={this.props.data}
                    goToProduct={(data) => {
                      this.props.ItemClick(data);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <hr />
        </div>
      </>
    );
  }
}
